// Footer.js
import React from 'react';
import './App.css'; // Ensure your CSS is imported

const Footer = () => {
    return (
        <footer>
            <p className="footer-text"></p>
            <div className="social-links">
                <a href="HTTPS://GITHUB.COM/samyakzer0" target = "_blank" rel="noopener noreferrer">GitHub</a>
                <a href="https://www.linkedin.com/in/samyak-gupta-7398892a2/" target = "_blank" rel="noopener noreferrer">LinkedIn</a>
                </div>
        </footer>
    );
};

export default Footer;
